import { EventEmitter, Input, Output, Component } from '@angular/core';
import { BasePage } from '../../base-page/base-page';
import { StepCodeEnum } from '../enum/step-code.enum';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-base-step',
    template: '',
    standalone: false
})
export class BaseStep extends BasePage {
  @Input() enableBackStep: boolean = true;
  @Input() enableNextStep: boolean = true;
  @Input() readonlyMode: boolean = false;
  @Input() isActive: boolean = false;
  @Input() hideSave: boolean = false;

  @Output() onPrevStep: EventEmitter<any> = new EventEmitter();
  @Output() onNextStep: EventEmitter<any> = new EventEmitter();
  @Output() onUpdateStep: EventEmitter<StepCodeEnum> = new EventEmitter(null);
  @Output() setDirty: EventEmitter<boolean> = new EventEmitter();

  prefixClass: string = '';

  constructor() {
    super();
  }

  public isEnterprise() {
    return environment.configuration.enterprise;
  }

  public addElement(array: any[], item: any) {
    if (array.indexOf(item) === -1) {
      array.push(item);
    }
  }

  public scrollTop() {
    window.scroll(0, 0);
  }
}
